import { HttpClient } from './client'
import type { HttpClientConfig } from './types'

// 默认配置
const defaultConfig: HttpClientConfig = {
  baseURL: import.meta.env.VITE_APP_API_URL || '/api',
  timeout: 15000,
  requestInterceptors: [
    {
      onFulfilled: (config) => {
        console.log(`[HTTP] ${config.method?.toUpperCase()} ${config.url}`)
        return config
      },
    },
  ],
  responseInterceptors: [
    {
      onFulfilled: (response) => {
        console.log(`[HTTP] Response:`, response.data)
        return response
      },
      onRejected: (error) => {
        console.error('[HTTP] Error:', error)
        return Promise.reject(error)
      },
    },
  ],
}

// 创建默认实例
const http = new HttpClient(defaultConfig)

// 导出类型
export * from './types'

// 导出类
export { HttpClient }

// 导出默认实例
export default http
